// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"63":"1cde0276","514":"2f03e5e0"}[chunkId] + ".chunk.css";
};